import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Hero Header element, used to display a big header with background image
 *
 * @slot - Unnamed slot (default slot)
 * @attribute image - mandatory, used to set the background image (url)
 * @attribute color - optional, used to set the color of the content card
 * @attribute noContent - optional, used to hide content card and only show image
 * @attribute height - optional, used to set the height of the hero header (default 450)
 * @attribute left - optional, used to display the contentcard on the leftside (default right)
 */
let SDBContentCatalogHeader = class SDBContentCatalogHeader extends LitElement {
    constructor() {
        super(...arguments);
        this.title = '';
        this.description = '';
    }
    render() {
        return html `
            <div id="background"></div>
            <div id="content">
                <div id="cardWrapper" @scroll=${this._checkNav}>
                    <div id="top"></div>
                    <div id="text">
                        <h1>${this.title}</h1>
                        <span>${this.description}</span>
                    </div>
                    <slot id="catalogCards"></slot>
                    <div id="bottom"></div>
                </div>
                <div id="navigation">
                    <div
                        id="navBarLeft"
                        class="navBar active"
                        @click="${this._scrollToTop}"
                    >
                        <sdb-content-icon
                            size="15"
                            light
                            icon="fal fa-chevron-left"
                        ></sdb-content-icon>
                        <span></span>
                    </div>
                    <div
                        id="navBarRight"
                        class="navBar"
                        @click="${this._scrollToEnd}"
                    >
                        <span></span>
                        <sdb-content-icon
                            size="15"
                            light
                            icon="fal fa-chevron-right"
                        ></sdb-content-icon>
                    </div>
                </div>
            </div>
        `;
    }
    firstUpdated() {
        this._initializeNav();
    }
    _initializeNav() {
        var _a;
        const nav = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#navigation');
        const wrapperCardsCount = document.querySelectorAll('sdb-content-catalogcard').length;
        if (wrapperCardsCount && wrapperCardsCount <= 3) {
            nav === null || nav === void 0 ? void 0 : nav.classList.add('hidden');
        }
        else {
            nav === null || nav === void 0 ? void 0 : nav.classList.remove('hidden');
        }
    }
    _checkNav() {
        var _a, _b, _c;
        const wrapper = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#cardWrapper');
        const left = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('#navBarLeft');
        const right = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('#navBarRight');
        const scrollCheck = wrapper === null || wrapper === void 0 ? void 0 : wrapper.scrollTop;
        if (scrollCheck && scrollCheck >= 160) {
            right === null || right === void 0 ? void 0 : right.classList.add('active');
            left === null || left === void 0 ? void 0 : left.classList.remove('active');
        }
        else {
            left === null || left === void 0 ? void 0 : left.classList.add('active');
            right === null || right === void 0 ? void 0 : right.classList.remove('active');
        }
    }
    _scrollToTop() {
        var _a, _b, _c;
        const top = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#top');
        const left = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('#navBarLeft');
        const right = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('#navBarRight');
        top === null || top === void 0 ? void 0 : top.scrollIntoView({ behavior: 'smooth' });
        left === null || left === void 0 ? void 0 : left.classList.add('active');
        right === null || right === void 0 ? void 0 : right.classList.remove('active');
    }
    _scrollToEnd() {
        var _a, _b, _c;
        const bottom = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#bottom');
        const left = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('#navBarLeft');
        const right = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('#navBarRight');
        bottom === null || bottom === void 0 ? void 0 : bottom.scrollIntoView({ behavior: 'smooth' });
        right === null || right === void 0 ? void 0 : right.classList.add('active');
        left === null || left === void 0 ? void 0 : left.classList.remove('active');
    }
};
SDBContentCatalogHeader.styles = [
    elements,
    css `
            :host {
                width: 100vw;
                margin-left: calc(-50vw + 50%);
                margin-right: calc(-50vw + 50%);
                display: block;
            }

            :host #background {
                position: absolute;
                display: block;
                height: 325px;
                width: 100vw;
                z-index: -1;
                background-color: var(--theme-primary);
            }

            :host #content {
                position: relative;

                height: 300px;
                margin: 0 auto;
                max-width: 1400px;
                width: calc(100% - 60px);
                padding: 0 30px;

                display: grid;
                grid-template-rows: 40px auto;
                grid-template-columns: 1fr;
                grid-column-gap: 15px;
                grid-template-areas:
                    'nav'
                    'cards';
            }

            @media (max-width: 854px) {
                :host #content {
                    display: grid;

                    padding: 0 15px;
                    width: calc(100% - 30px);
                    max-width: 767px;
                }

                :host #text {
                    display: none;
                }

                #cardWrapper {
                    height: 90vw !important;
                }
            }

            @media (max-width: 767px) {
                :host #background {
                    height: 280px;
                }

                :host #content {
                    display: grid;

                    padding: 0 15px;
                    width: calc(100% - 30px);
                    max-width: 767px;

                    grid-template-rows: 15px auto 15px !important;
                    grid-template-columns: 1fr !important;
                    grid-template-areas:
                        '.'
                        'cards'
                        '.';
                    grid-column-gap: 0;
                }

                #cardWrapper {
                    height: 93vw !important;
                }

                :host #text,
                :host #navigation {
                    display: none;
                }
            }

            @media (max-width: 311px) {
                :host {
                    display: none;
                }
            }

            #text {
                transform: rotate(90deg);
                color: white;
                display: block;
                height: 250px;
                width: 400px;
                padding-top: 150px;
            }

            #text h1 {
                margin-top: 0;
                font-weight: 400;
                width: 90%;
            }

            #text span {
                font-weight: 400;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 6;
                width: 90%;
            }

            #cardWrapper {
                display: grid;
                grid-template-columns: 1px 2fr repeat(1fr) 1px;
                grid-area: cards;
                position: absolute;
                top: 0;
                left: 0;
                width: calc(250px + 1px);
                height: 93vw;
                max-height: 1400px;
                margin: 0;
                padding-top: 1px;
                overflow-y: auto;
                overflow-x: hidden;
                transform: rotate(-90deg) translateY(-250px);
                transform-origin: right top;
            }

            @media (pointer: coarse) {
                #cardWrapper {
                    overflow-x: scroll; /* Must be 'scroll' not 'auto' */
                    -webkit-overflow-scrolling: touch;
                }
            }

            #navigation {
                grid-area: nav;
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
                padding: 0 20px;
                gap: 10px;
            }

            #navigation.hidden {
                display: none;
            }

            .navBar {
                display: flex;
                align-items: center;
                gap: 10px;
                height: 15px;
                background: transparent;
                cursor: pointer;
            }

            .navBar > span {
                display: block;
                height: 2px;
                width: 35px;
                background: RGBA(255, 255, 255, 0.5);
            }

            .navBar.active > span {
                background: RGBA(255, 255, 255, 0.9);
            }

            :host([hidden]),
            [hidden] {
                display: none;
            }

            ::-webkit-scrollbar {
                width: 1px;
                height: 1px;
            }

            ::-webkit-scrollbar-button {
                width: 1px;
                height: 1px;
            }
        `,
];
__decorate([
    property({ type: String })
], SDBContentCatalogHeader.prototype, "title", void 0);
__decorate([
    property({ type: String })
], SDBContentCatalogHeader.prototype, "description", void 0);
SDBContentCatalogHeader = __decorate([
    customElement('sdb-content-catalogheader')
], SDBContentCatalogHeader);
export { SDBContentCatalogHeader };
//# sourceMappingURL=sdb-content-catalogheader.js.map